var InfoView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

InfoView = (function() {
  function InfoView(with_items, options) {
    this.with_items = with_items != null ? with_items : false;
    if (options == null) {
      options = {};
    }
    this.previous = __bind(this.previous, this);
    this.next = __bind(this.next, this);
    this.move_info_box = __bind(this.move_info_box, this);
    this.hide_info_box = __bind(this.hide_info_box, this);
    this.show_info_box = __bind(this.show_info_box, this);
    this.toggle_info_box = __bind(this.toggle_info_box, this);
    Observable(this, 'asset');
    Observable(this, 'items_loaded', false);
    Observable(this, 'loaded', false);
    this.info_box_height = options.info_box_height != null ? options.info_box_height : 510;
    this.info_box_total = this.info_box_height + 200;
    this.scroll_offset = options.scroll_offset != null ? options.scroll_offset : 0;
    this.asset.subscribe((function(_this) {
      return function(asset) {
        if (_this.asset() == null) {
          return;
        }
        if (_this.asset().name() === "") {
          return _this.asset().edit_name();
        }
      };
    })(this));
    this.asset.subscribe((function(_this) {
      return function() {
        if (_this.asset() == null) {
          return;
        }
        return Tag.find(_this.asset().id, function(data) {
          var tag, _i, _len, _results;
          _this.asset().tags([]);
          _results = [];
          for (_i = 0, _len = data.length; _i < _len; _i++) {
            tag = data[_i];
            _results.push(_this.asset().tags.push(Tag(tag)));
          }
          return _results;
        });
      };
    })(this));
    if (this.with_items) {
      this.asset.subscribe((function(_this) {
        return function() {
          if (_this.asset() == null) {
            return;
          }
          _this.items_loaded(false);
          return Item.find(_this.asset().id, function(data) {
            var item, _i, _len;
            _this.asset().items([]);
            if (data.items) {
              data = data.items;
            }
            for (_i = 0, _len = data.length; _i < _len; _i++) {
              item = data[_i];
              _this.asset().items.push(Item(item));
            }
            return _this.items_loaded(true);
          });
        };
      })(this));
    }
  }

  InfoView.prototype.toggle_info_box = function(item, event) {
    var li;
    li = $(event.target).closest('li');
    if (li.hasClass('expanded')) {
      return this.hide_info_box();
    }
    return this.show_info_box(item, event);
  };

  InfoView.prototype.show_info_box = function(item, event) {
    var element, li;
    li = $(event.target).closest('li');
    this.asset(item);
    if (li.hasClass('expanded')) {
      return;
    }
    if ($('#info-box').length === 1) {
      this.move_info_box(li);
      return;
    }
    $(document).bind('keydown', 'left', this.previous);
    $(document).bind('keydown', 'right', this.next);
    $(document).bind('keydown', 'esc', this.hide_info_box);
    $('#tag_name_info').bind('keydown', 'return', this.asset.add_tag_ui);
    element = li.append('<div id="info-box" data-bind="template: {name: \'infoTemplate\', with: info}"></div>');
    li.attr('style', 'transition: height 350ms ease; -webkit-transition: height 350ms ease; height: ' + this.info_box_total + 'px');
    li.addClass('expanded');
    ko.applyBindings(this, $('#info-box').get(0));
    $('#info-box .info-box').attr('style', 'height: ' + this.info_box_height + 'px');
    $('#info-box .info-box-inner').attr('style', 'height: ' + (this.info_box_height - 10) + 'px');
    if (typeof all_tags !== "undefined") {
      $('.add-tag-input').typeahead({
        local: all_tags
      });
    }
    return $('html,body').animate({
      scrollTop: li.offset().top - this.scroll_offset
    });
  };

  InfoView.prototype.hide_info_box = function() {
    var old_li;
    old_li = $('#info-box').closest('li');
    old_li.attr('style', 'transition: height 350ms ease; -webkit-transition: height 350ms ease; height: auto');
    $('#info-box').remove();
    old_li.removeClass('expanded');
    $(document).unbind('keydown', this.previous);
    $(document).unbind('keydown', this.next);
    return $(document).unbind('keydown', this.hide_info_box);
  };

  InfoView.prototype.move_info_box = function(li) {
    var old_li;
    old_li = $('#info-box').parent();
    li.attr('style', 'height: ' + this.info_box_total + 'px');
    li.addClass('expanded');
    old_li.removeClass('expanded');
    old_li.attr('style', 'transition: height 350ms ease; -webkit-transition: height 350ms ease; height: auto');
    li.append($('#info-box'));
    if (typeof all_tags !== "undefined") {
      $('.add-tag-input').typeahead({
        local: all_tags
      });
    }
    return $('html,body').animate({
      scrollTop: li.offset().top - this.scroll_offset
    });
  };

  InfoView.prototype.next = function() {
    var old_li;
    if (assetsgrid.assets.indexOf(this.asset()) === assetsgrid.assets().length - 1) {
      return;
    }
    this.asset(assetsgrid.assets()[assetsgrid.assets.indexOf(this.asset()) + 1]);
    old_li = $('#info-box').parent();
    return this.move_info_box(old_li.next());
  };

  InfoView.prototype.previous = function() {
    var old_li;
    if (assetsgrid.assets.indexOf(this.asset()) === 0) {
      return;
    }
    this.asset(assetsgrid.assets()[assetsgrid.assets.indexOf(this.asset()) - 1]);
    old_li = $('#info-box').parent();
    return this.move_info_box(old_li.prev());
  };

  return InfoView;

})();

//# sourceMappingURL=0-info.js.map
